import FiltersFormContainer from './FiltersFormContainer';

export default FiltersFormContainer;
